import React from 'react';
import ComponentHelper from '../../supers/ComponentHelper';
import './connections-panel.css';
import HeaderBreadcrumb from '../../components/header-breadcrumb/HeaderBreadcrumb';
import ConnectionCreator from './connection-creator/ConnectionCreator';
import ConnectionList from './connection-list/ConnectionList';
import { NavLink, Redirect, Route } from 'react-router-dom';
import ConnectionEditor from './connection-editor/ConnectionEditor';

class ConnectionsPanel extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			activePage: this.getActivePath()
		};
		this.autoBind(['onBack', 'onCreateConnection', 'onEditConnection', 'onTestConnection']);
	}

	getActivePath = () => {
		return this.props.location.pathname === '/connections' ? 'list' : 'creator';
	};

	onBack() {
		this.setData('activePage', 'list');
	}

	onCreateConnection() {
		this.setData('activePage', 'creator');
	}

	onEditConnection(connection) {
		this.observe(() => {
			this.data.editing = connection;
			this.data.activePage = 'editor';
		});
	}

	onTestConnection(connection) {
		this.observe(() => {
			this.data.editing = connection;
			this.data.activePage = 'testing';
		});
	}

	buildHeaderButtons = () => {
		let { match } = this.props;
		if (this.props.location.pathname !== '/connections') {
			return (
				<NavLink to={`${match.url}`}>
					<button className="btn" data-page="list" onClick={this.onBack}>
						Back
					</button>
				</NavLink>
			);
		}
		return '';
	};

	getHeaderText = () => {
		switch (this.data.activePage) {
			case 'list': {
				return 'Connections';
			}
			case 'creator': {
				return 'New Connection';
			}
			case 'editor': {
				return 'Edit Connection';
			}
			case 'testing': {
				return 'Test Connection';
			}
			default: {
				return 'Connections';
			}
		}
	};

	render() {
		let { activePage } = this.data;
		let { match } = this.props;
		return (
			<div className="connections-panel-view animated fadeIn">
				<div className="header hbox">
					<HeaderBreadcrumb currentPage={this.getHeaderText()} className="grow-1" />
					{this.buildHeaderButtons()}
				</div>
				{activePage === 'list' && (
					<div className="sub-title">
						Connections are sets of configurations that allow you to connect to an external service. You can create any number of Integration
						Endpoints based on a given Connection.
					</div>
				)}
				<Route
					exact
					path={`${match.url}`}
					render={routeProps => (
						<ConnectionList
							{...routeProps}
							onCreateConnection={this.onCreateConnection}
							onEditConnection={this.onEditConnection}
							onTestConnection={this.onTestConnection}
							key="connection-list-on-panel-key"
						/>
					)}
				/>
				<Route path={`${match.url}/create`} component={ConnectionCreator} />
				{this.data.editing && (
					<Route path={`${match.url}/edit`} render={routeProps => <ConnectionEditor {...routeProps} connection={this.data.editing} />} />
				)}
				{!this.data.editing && <Route path={`${match.url}/edit`} render={() => <Redirect to={`/connections`} />} />}
			</div>
		);
	}
}

export default ConnectionsPanel;



// WEBPACK FOOTER //
// ./src/views/connections-panel/ConnectionsPanel.js